import { Skeleton } from '@/components/ui/skeleton';

export const HeroSlidesSkeleton = () => {
  return (
    <div className="relative h-[550px] w-full overflow-hidden bg-muted md:h-[550px] lg:h-[600px] xl:h-[80vh]">
      {/* Main image skeleton */}
      <div className="absolute inset-0">
        <Skeleton className="h-full w-full rounded-none" />
      </div>

      {/* Content overlay skeleton */}
      <div className="absolute inset-0 flex flex-col justify-end overflow-hidden bg-gradient-to-t from-black/30 to-transparent p-6 md:p-8">
        <div className="mx-auto w-full max-w-3xl space-y-4 text-center">
          <Skeleton className="mx-auto h-8 w-3/4 md:h-10 md:w-1/2" />
          <Skeleton className="mx-auto h-4 w-5/6 md:h-5 md:w-2/3" />
          <Skeleton className="mx-auto h-4 w-3/4 md:h-5 md:w-1/2" />
        </div>
      </div>

      {/* Navigation controls skeleton */}
      <div className="absolute left-4 top-1/2 z-10 -translate-y-1/2">
        <Skeleton className="h-10 w-10 rounded-full" />
      </div>
      <div className="absolute right-4 top-1/2 z-10 -translate-y-1/2">
        <Skeleton className="h-10 w-10 rounded-full" />
      </div>

      {/* Dot indicators skeleton */}
      <div className="absolute bottom-6 left-1/2 z-10 flex -translate-x-1/2 gap-2">
        {[...Array(3)].map((_, i) => (
          <Skeleton key={i} className="h-2.5 w-2.5 rounded-full" />
        ))}
      </div>
    </div>
  );
};
